import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/lib/api';
import { useAuth } from './AuthContext';

const DBAContext = createContext(null);

export function DBAProvider({ children }) {
  const { user } = useAuth();
  const [dbas, setDbas] = useState([]);
  const [selectedDBA, setSelectedDBA] = useState(null);

  const fetchDBAs = useCallback(async () => {
    try {
      const { data } = await api.get('/dbas');
      setDbas(data);
    } catch { return; }
  }, []);

  useEffect(() => {
    if (user) fetchDBAs();
  }, [user, fetchDBAs]);

  const getDBAName = useCallback((id) => {
    const dba = dbas.find(d => d.id === id);
    return dba ? dba.name : '';
  }, [dbas]);

  const getDBAColor = useCallback((id) => {
    const dba = dbas.find(d => d.id === id);
    return dba ? dba.color : '#09090b';
  }, [dbas]);

  return (
    <DBAContext.Provider value={{ dbas, selectedDBA, setSelectedDBA, fetchDBAs, getDBAName, getDBAColor }}>
      {children}
    </DBAContext.Provider>
  );
}

export function useDBA() {
  return useContext(DBAContext);
}
